import './mls-french.scss';
import { MLS_HIDE_SEO_BREADCRUMB_IDS, MLS_BANNER_BOTTOM_RIGHT_IDS } from '../../common/mls';

export default ({ globalData }) => {
    let mlsOrgs = globalData.mlsOrgs || [];
    for (let i = 0; i < mlsOrgs.length; i++) {
        let mls = mlsOrgs[i];
        if (MLS_HIDE_SEO_BREADCRUMB_IDS.includes(mls.id)) {
            document.body.classList.add('use_mls_french');
        }
        if (MLS_BANNER_BOTTOM_RIGHT_IDS.includes(mls.id)) {
            document.body.classList.add('use_mls_adjust_position_banner');
        }
    }
};
